import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poDisclaimerRepository } from '@webapp/modules/purchasing/data-access/repositories/PODisclaimerRepository'
import { type CreatePODisclaimerLabelFormSchema } from '@webapp/modules/purchasing/features/create-po-disclaimer-label/views/CreatePODisclaimerLabelForm'
import { poDisclaimerLabelQueryConfig } from '@webapp/modules/purchasing/query-configs/poDisclaimerLabel'

export const useMutateCreatePODisclaimerLabel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    CreatePODisclaimerLabelFormSchema
  >({
    mutationFn: (values) =>
      poDisclaimerRepository.create({
        description: values.description,
        text: values.text,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: poDisclaimerLabelQueryConfig.all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
